// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2018 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.theia-console-content {
  font-size: var(--theia-code-font-size);
  line-height: var(--theia-code-line-height);
  font-family: var(--theia-code-font-family);
}

.theia-console-input {
  padding-left: 20px;
  border-top: var(--theia-panel-border-width) solid var(--theia-panel-border);
  height: calc(var(--theia-content-line-height) * 2);
  display: flex;
  align-items: center;
}

.theia-console-input:before {
  left: 8px;
  top: 3px;
  position: absolute;
  content: "\\276f";
  line-height: 18px;
}

.theia-console-error {
  color: var(--theia-errorForeground);
}

.theia-console-warning {
  color: var(--theia-editorWarning-foreground);
}

.theia-console-ansi-console-item {
  white-space: pre-wrap;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/console/src/browser/style/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,2EAA2E;EAC3E,kDAAkD;EAClD,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["/********************************************************************************\n * Copyright (C) 2018 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.theia-console-content {\n  font-size: var(--theia-code-font-size);\n  line-height: var(--theia-code-line-height);\n  font-family: var(--theia-code-font-family);\n}\n\n.theia-console-input {\n  padding-left: 20px;\n  border-top: var(--theia-panel-border-width) solid var(--theia-panel-border);\n  height: calc(var(--theia-content-line-height) * 2);\n  display: flex;\n  align-items: center;\n}\n\n.theia-console-input:before {\n  left: 8px;\n  top: 3px;\n  position: absolute;\n  content: \"\\276f\";\n  line-height: 18px;\n}\n\n.theia-console-error {\n  color: var(--theia-errorForeground);\n}\n\n.theia-console-warning {\n  color: var(--theia-editorWarning-foreground);\n}\n\n.theia-console-ansi-console-item {\n  white-space: pre-wrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
